import React from 'react'
import classes from './categorie-item-styling.module.scss'
import { FaTimes } from 'react-icons/fa';

export const CategorieItem = ({catToShow,
                                  categorie,
                                  updateParam,
                                  deleteParam,
                                  isChild = false
                              }) => {

    const handleClick = (id) => {
        updateParam('cat', id)
    }
    const handleDelClick = () => {
        deleteParam('cat')
    }

    let show = categorie?.id === catToShow
    let subshow = !show && categorie.children_recursive_has_wiki_kenniscentrum?.some(subCat => subCat?.id === catToShow
        || subCat.children_recursive_has_wiki_kenniscentrum?.some(subSubCat => subSubCat?.id === catToShow))

    return <div key={`${categorie?.id}`} className={`${classes.catItemContainer} ${isChild && classes.isChild}`}>
        <div className={show ? classes.catItemActive : classes.catItemNotActive} onClick={() => handleClick(show ? null : categorie.id)}>
            <span>{categorie?.categorie_talen_in_taal[0]?.categorie_taal?.naam}</span>
            {show && <span className={classes.activeReset}><FaTimes onClick={handleDelClick} /></span>}
        </div>

        {(show || subshow) && categorie.children_recursive_has_wiki_kenniscentrum &&
            categorie.children_recursive_has_wiki_kenniscentrum.map((cat) => {
                return <CategorieItem
                    isChild={true}
                    categorie={cat}
                    catToShow={catToShow}
                    updateParam={updateParam}
                />
            })}
    </div>
}